import React from "react";

const sizes = {
  "default": "cs-size-6 cs-ms-4",
  "small": "cs-size-4 cs-ms-2",
  "extra-small": "cs-size-2 cs-ms-1.5",
}

export default function DotLoader({size = "default"}) {

  return (
    <div className="cs-flex cs-justify-center cs-items-center cs-size-full">
      <span className={`${sizes[size]} ${size === "extra-small" ? "cs-animate-[wave_1.3s_ease-in-out_infinite]" : "cs-animate-[initialWave_1.3s_ease-in-out_infinite]"} cs-rounded-full cs-bg-greenColor`}></span>
      <span className={`${sizes[size]} ${size === "extra-small" ? "cs-animate-[wave_1.3s_-1.1s_ease-in-out_infinite]" : "cs-animate-[initialWave_1.3s_-1.1s_ease-in-out_infinite]"} cs-rounded-full cs-bg-orangeColor`}></span>
      <span className={`${sizes[size]} ${size === "extra-small" ? "cs-animate-[wave_1.3s_-0.9s_ease-in-out_infinite]" : "cs-animate-[initialWave_1.3s_-0.9s_ease-in-out_infinite]"} cs-rounded-full cs-bg-loaderBlue`}></span>
    </div>
  );
}